<template>
    <div>
        <div class="ft-origin-destination-lable origin fs-subtext-bk">{{origin}}</div>
        <span class="ft-vertical-line"/>
        <div class="ft-origin-destination-lable destination fs-subtext-bk">{{destination}}</div>
    </div>
</template>

<script>
export default {
    props: {
        origin: String,
        destination: String
    }
}
</script>

<style lang="scss">
.ft-origin-destination-lable {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin: 0.45rem 0;

    &::before {
        content: "";
        height: 10px;
        width: 10px;
        display: inline-block;
        z-index: 4;
        margin: 0.5rem 1.5rem 0rem 0;
        box-sizing: border-box;
        border-radius: 50%;
        background-color: #D6D6D6;
        border: 1px solid #707070;
       
    }

    &.origin::before {
        background-color: #59C591;
        border: 1px solid #117D4A;
    }

    &.destination::before {
        background-color: #F6BEBF;
        border: 1px solid #E33436;
    }
}
.ft-vertical-line {
    position: absolute;
    width: 15px;
    height: 0px;
    left: 12px;
    top: 33.51px;
    background-color: #ADADAD;
    border: 1px solid #ADADAD;
    transform: rotate(-90deg);
    border-radius: 5px;
}
</style>